import React, { useEffect, useRef, useState } from "react";
import { withFormik, Form, Field, Formik } from "formik";
import { playLevelsOptions, schoolTypeOptions } from "../../../utils/constant";
import validationSchema from "../../../Validation/ValidationSchemas";
import { FormGroup } from "@material-ui/core";
import "./SignUp.css";
import userService from "../../../services/user.service";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import ReCaptchaComponent from "../../ReCaptcha/ReCaptchaComponent";
import { useHistory } from "react-router-dom";

const SignUpDetailForm = (props) => {
  const {
    values: { country },
    countryList,
  } = props;

  const myref = useRef();
  const [signUpFormData, setSignUpFormData] = useState({
    countryName: "",
    stateName: "",
    schoolType: "",
    playLevel: "",
  });
  const [stateList, setStateList] = useState([]);
  const [captchaValue, setCaptchaValue] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (signUpFormData.countryName) {
      let countryObject = countryList.find(
        ({ name }) => name === signUpFormData.countryName
      );
      userService.getAllStateOfCountry(countryObject?.id).then((response) => {
        setStateList(response?.data?.data || []);
      });
    }
  }, [signUpFormData.countryName]);

  const formatNumber = (phNumber) => {
    let cleaned = ("" + phNumber).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let inputString = "(" + match[1] + ") " + match[2] + "-" + match[3];
      myref.current.setFieldValue("phoneNumber", inputString);
    }
  };

  const updateSignUpFormData = (name, value) => {
    setSignUpFormData((previousSignupFormData) => {
      return {
        ...previousSignupFormData,
        [name]: value,
      };
    });
  };

  return (
    <Formik
      innerRef={myref}
      initialValues={{
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        country: "",
        schoolName: "",
        sport: "Football",
        signUpMessage: "",
        schoolType: "",
        state: "",
        playLevel: "",
        captchaValue: null,
      }}
      validationSchema={validationSchema.signUpSchema}
      onSubmit={(values, { resetForm }) => {
        props.submitSignUp(values, resetForm);
      }}
    >
      {(formik) => (
        <Form className="form-container">
          <div className="two-column-row">
            <div className="grid-col-container">
              <FormikTextField
                label="First Name"
                formik={formik}
                fieldName="firstName"
                placeholder="Enter First name"
                labelFontSize="fs-18"
              />
            </div>

            <div className="grid-col-container">
              <FormikTextField
                label="Last Name"
                formik={formik}
                fieldName="lastName"
                placeholder="Enter Last name"
                labelFontSize="fs-18"
              />
            </div>

            <div className="grid-col-container">
              <FormikTextField
                label="Email"
                formik={formik}
                fieldName="email"
                placeholder="Enter Email Address"
                labelFontSize="fs-18"
              />
            </div>

            <div className="grid-col-container">
              <FormikTextField
                label="Phone Number"
                formik={formik}
                fieldName="phoneNumber"
                placeholder="Enter Phone Number"
                labelFontSize="fs-18"
                onKeyUp={(e) => formatNumber(e.target.value)}
                maxLength={14}
              />
            </div>

            <div className="grid-col-container fs-14">
              <FormGroup>
                <label className="fmlabel mt-6 semi-bold fs-18">
                  Country <span className="redstar">*</span>
                </label>
                <CustomDropDown
                  selected={signUpFormData.countryName}
                  setSelected={(value) =>
                    updateSignUpFormData("countryName", value)
                  }
                  formik={formik}
                  fieldName="country"
                  defaultSelectOption="Select Country"
                  options={countryList}
                  fieldToShow="name"
                  optionValue="name"
                  isDisabled="disabled"
                />
              </FormGroup>
            </div>

            <div className="grid-col-container fs-14 mt-m-25">
              <FormGroup>
                <label className="fmlabel mt-6 semi-bold fs-18">
                  Select State <span className="redstar">*</span>
                </label>
                <CustomDropDown
                  selected={signUpFormData.stateName}
                  setSelected={(value) =>
                    updateSignUpFormData("stateName", value)
                  }
                  formik={formik}
                  fieldName="state"
                  defaultSelectOption="Select State"
                  options={stateList}
                  fieldToShow="name"
                  optionValue="name"
                  disabledDropdown={formik.values.country ? false : true}
                />
              </FormGroup>
            </div>

            <div className="grid-col-container mt-25">
              <FormikTextField
                label="School Name"
                formik={formik}
                fieldName="schoolName"
                placeholder="Enter School Name"
                labelFontSize="fs-18"
              />
            </div>

            <div className="grid-col-container mt-25">
              <FormGroup>
                <label className="fmlabel mt-6 semi-bold fs-18">
                  School Type <span className="redstar">*</span>
                </label>
                <CustomDropDown
                  selected={signUpFormData.schoolType}
                  setSelected={(value) =>
                    updateSignUpFormData("schoolType", value)
                  }
                  formik={formik}
                  fieldName="schoolType"
                  defaultSelectOption="Select School Type"
                  options={schoolTypeOptions}
                  fieldToShow="name"
                  optionValue="name"
                  isDisabled="disabled"
                />
              </FormGroup>
            </div>
          </div>

          <div className="grid-col-container mt-m-25">
            <FormikTextField
              label="Sport"
              formik={formik}
              fieldName="sport"
              placeholder="Select Sport"
              labelFontSize="fs-18"
              isDisabled={true}
            />
            <FormGroup className="fs-14">
              <label className="fmlabel mt-6 semi-bold fs-18">
                Play Level <span className="redstar">*</span>
              </label>
              <CustomDropDown
                selected={signUpFormData.playLevel}
                setSelected={(value) =>
                  updateSignUpFormData("playLevel", value)
                }
                formik={formik}
                fieldName="playLevel"
                defaultSelectOption="Select Play Level"
                options={playLevelsOptions}
                fieldToShow="name"
                optionValue="name"
                isDisabled="disabled"
              />
            </FormGroup>

            <div className="grid-col-container mt-25">
              <FormikTextField
                label="Any Message"
                formik={formik}
                fieldName="signUpMessage"
                placeholder="Type Your Message Here..."
                labelFontSize="fs-18"
                isTextArea={true}
                rows="4"
                cols="50"
                notRequired={true}
              />
            </div>
          </div>
          <ReCaptchaComponent
            setCaptchaValue={(value) =>
              formik.setFieldValue("captchaValue", value)
            }
          />
          <div
            className={`form-item form-button-item mg-top-20 ${
              !formik.isValid && "inactive-btn"
            }`}
          >
            <button
              disabled={!formik.isValid}
              type="submit"
              className={`${!formik.isValid ? "opacity07" : ""}`}
            >
              Sign Up
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export const SignUpForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      firstName: props?.firstName || "",
      lastName: props?.lastName || "",
      phoneNumber: props?.phoneNumber || "",
      email: props?.email || "",
      country: props?.country || "",
      state: props?.state || "",
      schoolName: props?.schoolName || "",
      schoolType: props?.schoolType || "",
      sport: props?.sport || "",
      anyMessage: props?.anyMessage || "",
      captchaValue: props?.captchaValue,
    };
  },

  handleSubmit: (values, { props, resetForm }) => {
    props?.submitSignUp(values, resetForm);
  },
})(SignUpDetailForm);
